import {useState} from 'react';
import {Moment} from 'moment';
import {DatePicker, Modal} from 'antd';
import {DownloadOutlined} from '@ant-design/icons';

// Components
import ButtonComponent from '../../subComponents/ButtonComponent';

// Store
import {useAppDispatch} from '../../../store/store';
import {downloadFile} from '../../../store/redux/actions/containerShipmentActions';

const {RangePicker} = DatePicker;

type PropsType = {
  onToggleModal: (visible: boolean) => void;
  visibleRange: [Moment, Moment];
};

const DownloadCalendarModal = ({onToggleModal, visibleRange}: PropsType) => {
  const dispatch = useAppDispatch();
  const [selectedRange, setSelectedRange] = useState<[Moment, Moment] | null>(null);

  const handleDownload = () => {
    const [startDate, endDate] = selectedRange ?? visibleRange;
    dispatch(downloadFile(startDate.toDate(), endDate.toDate()));
    onToggleModal(false);
  };

  return (
    <Modal
      title={'Descargar calendario'}
      open={true}
      maskClosable
      closable={false}
      keyboard={false}
      destroyOnClose={true}
      footer={[
        <ButtonComponent
          key={'cancel'}
          text={'Cancelar'}
          className={'w-32 h-8 bg-white border border-grey-dkt-300 leading-4 text-grey-dkt-700 ' +
            'hover:bg-grey-dkt-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-dkt-400'}
          onClick={() => onToggleModal(false)}
        />,
        <ButtonComponent
          key={'download'}
          text={'Descargar'}
          icon={<DownloadOutlined />}
          className={'w-32 h-8 text-white bg-blue-dkt-400 hover:bg-blue-dkt-500 focus:outline-none focus:ring-2 ' +
            'focus:ring-offset-2 focus:ring-blue-dkt-300 after:content-none'}
          onClick={handleDownload}
        />,
      ]}
    >
      <RangePicker
        className={'w-full'}
        value={selectedRange}
        onChange={dates => setSelectedRange(dates as [Moment, Moment] | null)}
        format={'DD/MM/YYYY'}
        placeholder={['Fecha inicial', 'Fecha final']}
      />
      <p className={'mt-3 text-sm text-grey-dkt-500'}>
        Si no seleccionas fechas, se descargará el mes visible del calendario.
      </p>
    </Modal>
  );
};

export default DownloadCalendarModal;
